
import { CTA, styled, Text, TextAlignment, TextTag } from '@volkswagen-onehub/components-core';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Sorry } from './Sorry';
import { getTranslations } from '../translations';
import { DealerData } from '../types';
import { useDealersStore } from '../utils/use-dealers-store';

interface NotFoundInterface {
    header: string;
    subhead: string | JSX.Element;
    copy: string;
}

const ButtonWrapper = styled.div`
  margin-top: 16px;
`;

const NotFound : React.FC<NotFoundInterface> = ({copy, header, subhead}) => {
  const { error_messages: { "404": translations } } = getTranslations();
  const { isLoading, localDealer } = useDealersStore();

  const location = useLocation();

  return (
    isLoading
    ? <></>
    : <Sorry
      header={header}
      subhead={subhead}
    >
      {
        !location.pathname?.includes('favourites') && localDealer
        ? <Text tag={TextTag.p} textAlign={TextAlignment.center}>
          { translations.copy.replace("%%localDealer%%", ((localDealer as DealerData)?.name)) }
        </Text>
        : null
      }
      <ButtonWrapper>
        <Link to={`/`}>
          <CTA
            tag="button"
            emphasis="primary"
            // ariaLabel={}
          >
            { copy }
          </CTA>
        </Link>
      </ButtonWrapper>
    </Sorry>
  );
};

export default NotFound;
